/**
 * ProtocolDistributor acts as a router to one or many loggers.
 * not injectable itself, but injetable instances can be created using injectableProtocolFactory.
 */
export class ProtocolDistributor {
  constructor(registry, name) {
    this.name = name;
    this.groupIdMaxLength = false;
    this.loggers = [];
    this.groupNameProcessor = name => '' + name;
    this.displayName = name;
    registry.register(this);
    this.write('log created');
  }
  passMessageToLoggers(entry) {
    this.loggers.forEach(logger => {
      if (logger.enabled) logger.log(entry);
    });
  }
  setGroupNameProcessor(fn) {
    this.groupNameProcessor = fn;
  }
  findLoggerOfType(loggerCtor) {
    const logger = this.loggers.find(l => l instanceof loggerCtor);
    return logger || null;
  }
  enableLogging(enable, loggerCtor) {
    if (loggerCtor) {
      const logger = this.findLoggerOfType(loggerCtor);
      logger.setEnabled(enable);
    } else {
      this.loggers.forEach(logger => {
        logger.setEnabled(enable);
      });
    }
  }
  write(message, data) {
    this.passMessageToLoggers({
      message,
      group: null,
      data,
      date: new Date()
    });
  }
  writeToGroup(groupInfo, message, data) {
    this.passMessageToLoggers({
      message,
      group: groupInfo ? this.groupNameProcessor(groupInfo) : null,
      data,
      date: new Date()
    });
  }
  registerLogger(logger) {
    logger.setEnabled(true);
    logger.assignToProtocol(this);
    this.loggers.push(logger);
  }
  setDisplayName(name) {
    this.displayName = name;
  }
}